import { type FC } from "react";

import { Breadcrumb } from "@snapchat/snap-design-system";

import { useApiManagementRoutes } from "../../../core/routes/hooks";

import { BreadcrumbItem, breadcrumbContainer } from "./DetailsBreadcrumbs.styles";
import { ApisLabel } from "./messages.generated";

interface DetailsBreadcrumbs {
    apiName: string;
}

export const DetailsBreadcrumbs: FC<DetailsBreadcrumbs> = ({ apiName }) => {
    const { goToApisList } = useApiManagementRoutes();

    return (
        <div className={breadcrumbContainer}>
            <Breadcrumb>
                <Breadcrumb.Item onClick={goToApisList}>
                    <BreadcrumbItem>
                        <ApisLabel />
                    </BreadcrumbItem>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <BreadcrumbItem active={true}>{apiName}</BreadcrumbItem>
                </Breadcrumb.Item>
            </Breadcrumb>
        </div>
    );
};
